import { usePlans } from "@/hooks/usePlans";
import { getPlanColor } from "@/utils/colors";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { usePreviewFilterStore } from "@/stores/previewFilterStore";
import { useCurrencyStore } from "@/stores/currencyStore";
import { formatCurrency } from "@/utils/currencyFormatter";

interface PreviewPlanLegendProps {
  providerId: number;
  versionId: number;
}

export function PreviewPlanLegend({ providerId, versionId }: PreviewPlanLegendProps) {
  const { data: plans, isLoading } = usePlans(providerId, versionId);
  const { 
    showPlanDescription, 
    showPlanMonthlyPrice, 
    showPlanYearlyPrice 
  } = usePreviewFilterStore();
  const providerCurrency = useCurrencyStore.getState().getProviderCurrency(providerId);
  
  if (isLoading || !plans || plans.length === 0) {
    return null;
  }

  return (
    <div className="mb-6 border rounded-md p-4">
      <h4 className="text-sm font-medium mb-3">Plan Legend</h4>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[70px]">Color</TableHead>
            <TableHead>Plan Name</TableHead>
            {showPlanMonthlyPrice && (
              <TableHead>Monthly Price</TableHead>
            )}
            {showPlanYearlyPrice && (
              <TableHead>Yearly Price</TableHead>
            )}
            {showPlanDescription && (
              <TableHead>Description</TableHead>
            )}
            <TableHead className="text-right">Channels</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {plans.map((plan) => {
            const color = getPlanColor(plan.color_index);
            return (
              <TableRow key={plan.id}>
                <TableCell>
                  <div 
                    className="w-5 h-5 rounded-full" 
                    style={{ 
                      backgroundColor: color.light,
                      border: `1px solid ${color.dark}`
                    }}
                  />
                </TableCell>
                <TableCell>{plan.name}</TableCell>
                {showPlanMonthlyPrice && (
                  <TableCell>{formatCurrency(plan.monthly_price, providerCurrency)}</TableCell>
                )}
                {showPlanYearlyPrice && (
                  <TableCell>{formatCurrency(plan.yearly_price, providerCurrency)}</TableCell>
                )}
                {showPlanDescription && (
                  <TableCell>{plan.description || "-"}</TableCell>
                )}
                <TableCell className="text-right">{plan.channel_count || 0}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
} 